module.exports = __webpack_public_path__ + "img/Recurso 24@300x.6e59c708.png";